<template>
  <div>
    <div v-if="loading" class="text-center my-3">
      <b-spinner />
    </div>
    <b-alert v-else-if="loadError" show variant="danger">
      Не удалось загрузить фото
    </b-alert>
    <div v-else-if="!photos.length" class="text-muted">
      Фото нет
    </div>
    <b-row v-else>
      <b-col
        v-for="photo in photos"
        :key="photo.url"
        cols="6"
        md="3"
        xl="2"
        class="mb-2"
      >
        <div class="person-photos__item" :class="{ 'person-photos__item--current': photo.url === currentPhoto }">
          <a :href="photo.url" target="_blank">
            <b-img :src="photo.url" fluid rounded class="person-photos__image" />
          </a>
          <div class="d-flex align-items-center justify-content-between mt-50">
            <b-badge variant="light-secondary">{{ sourceLabels[photo.source] || photo.source }}</b-badge>
            <b-badge v-if="photo.url === currentPhoto" variant="light-success">основное</b-badge>
            <b-button
              v-else-if="canManage"
              size="sm"
              variant="flat-primary"
              :disabled="savingUrl !== null"
              @click="select(photo)"
            >
              <b-spinner v-if="savingUrl === photo.url" small />
              <span v-else>Сделать основным</span>
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BAlert, BBadge, BButton, BCol, BImg, BRow, BSpinner,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BAlert, BBadge, BButton, BCol, BImg, BRow, BSpinner,
  },
  props: {
    personId: { type: Number, required: true },
    currentPhoto: { type: String, default: null },
  },
  data() {
    return {
      photos: [],
      loading: true,
      loadError: false,
      savingUrl: null,
      sourceLabels: { kp: 'КП', poiskkino: 'КП (оригинал)', tmdb: 'TMDb' },
    }
  },
  computed: {
    canManage() {
      return this.$can('manage', 'db-movies')
    },
  },
  created() {
    this.$http.get(`/person/${this.personId}/photos`)
      .then(res => { this.photos = res.data.data })
      .catch(() => { this.loadError = true })
      .finally(() => { this.loading = false })
  },
  methods: {
    select(photo) {
      this.savingUrl = photo.url
      this.$http.post(`/person/${this.personId}`, { photo: photo.url })
        .then(res => this.$emit('select', res.data.data))
        .catch(() => {
          this.$toast({
            component: ToastificationContent,
            props: { title: 'Не удалось сменить фото', variant: 'danger', icon: 'AlertTriangleIcon' },
          })
        })
        .finally(() => { this.savingUrl = null })
    },
  },
}
</script>

<style lang="scss" scoped>
.person-photos__item {
  padding: 0.25rem;
  border: 2px solid transparent;
  border-radius: 0.428rem;
}
.person-photos__item--current {
  border-color: #28c76f;
}
.person-photos__image {
  width: 100%;
  aspect-ratio: 2 / 3;
  object-fit: cover;
}
</style>
